var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-card-text",
        [
          _c("img", { attrs: { src: "/static/images/chart.svg" } }),
          _vm._v(" "),
          _c(
            "v-list",
            [
              _c(
                "v-list-tile",
                [
                  _c("v-list-tile-title", [_vm._v("Start Date")]),
                  _vm._v(" "),
                  _c("v-list-tile-sub-title", [_vm._v("May 1, 2017")]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-tile",
                [
                  _c("v-list-tile-title", [_vm._v("End Date")]),
                  _vm._v(" "),
                  _c("v-list-tile-sub-title", [_vm._v("May 1, 2017")]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-actions",
        [
          _c(
            "v-btn",
            { staticClass: "mr-2", attrs: { color: "cyan", dark: "" } },
            [
              _c("v-icon", [_vm._v("image")]),
              _vm._v(_vm._s(_vm.$t("Button.ShowasGraph")) + "\n    "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            { staticClass: "mr-2", attrs: { color: "green", dark: "" } },
            [
              _c("v-icon", [_vm._v("file_download")]),
              _vm._v(
                _vm._s(_vm.$t("Button.DownloadRawDatatoExcel")) + "\n    "
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            { attrs: { color: "green darken-2", dark: "" } },
            [
              _c("v-icon", { staticClass: "mr-2" }, [_vm._v("wb_sunny")]),
              _vm._v(_vm._s(_vm.$t("Button.DownloadDailyData")) + "\n    "),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }